import Moment from "moment-timezone";
import {
  toDate,
  endOfDay,
  isAfter,
  addDays,
  parseISO,
  differenceInCalendarDays,
  formatDistanceToNowStrict,
} from "date-fns";
import { enUS, ja } from "date-fns/locale";
import { getLocale } from "@/lib/localeHelper";

type inputDate = null | string | Date;

function parseDateToMomentObject(date: inputDate = new Date()) {
  if (date === null) date = new Date();
  if (!(date instanceof Date) && isNaN(Number(date))) {
    date = new Date(date);
  } else if (typeof date === "string" && !isNaN(Number(date))) {
    date = new Date(Number(date));
  }
  return Moment(date);
}

function formatDate(date: inputDate = new Date(), format: string = "MM/DD/YYYY"): string {
  return parseDateToMomentObject(date).format(format);
}

function dateFromNow(date: inputDate) {
  return parseDateToMomentObject(date).fromNow();
}

function stringToTimestamp(date: string, format = "MM/DD/YYYY"): number {
  if (typeof date !== "string" || date.length === 0) {
    throw new Error("Date should be string");
  }
  return Moment(date, format)
    .toDate()
    .getTime();
}

const timeZoneList = Moment.tz.names();

export function parseTimeFrom(time: string) {
  return parseISO(time).toISOString();
}

export function parseTimeTo(time: string) {
  return endOfDay(parseISO(time)).toISOString();
}

export function getFixedISODate(isoDate: string): Date {
  return new Date(isoDate.replace("-", "/").replace(/T.+/, ""));
}

interface ITimeAgoOptions {
  addSuffix?: boolean;
  locale?: string;
}

export function timeAgo(
  time: Date | string | number,
  { addSuffix, locale }: ITimeAgoOptions = { addSuffix: false }
): string {
  let localeOptions: Locale | undefined;
  const localeName = locale || getLocale();
  const date = typeof time === "string" ? parseISO(time) : toDate(time);

  if (localeName === "en-US") localeOptions = enUS;
  if (localeName === "ja") localeOptions = ja;

  return formatDistanceToNowStrict(date, { addSuffix, locale: localeOptions });
}
export { formatDate, stringToTimestamp, timeZoneList, dateFromNow, isAfter, differenceInCalendarDays, addDays };
